/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateGroupOrderParticipant} from '../api'

export const useMutationUpdateGroupOrderParticipant = createReactQueryMutationHook('updateGroupOrderParticipant', updateGroupOrderParticipant)
